/**
 * The current time, re-read every `intervalMs` while `active` — drives the
 * waiting and overtime clocks. Idle (no timer at all) when `active` is false,
 * so a trip that is not at the pickup costs nothing.
 */
import { useEffect, useState } from 'react';

export default function useNow(active = true, intervalMs = 1000) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!active) return undefined;
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [active, intervalMs]);

  return now;
}
